import React from "react";
import styled from "@emotion/styled";
import {Link, useNavigate} from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button as MuiButton, Typography } from "@mui/material";
import { spacing, SpacingProps } from "@mui/system";
import {useTranslation} from "react-i18next";

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const Button = styled(MuiButton)<ButtonProps>(spacing);

const Wrapper = styled.div`
  text-align: center;
`;

function Page404() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Helmet title="404 Error" />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        404
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        {t("pages.404.pageNotFound")}
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        {t("pages.404.pageRemoved")}
      </Typography>

      <Button
        component={Link}
        onClick={() => navigate(-1)}
        variant="contained"
        color="secondary"
        mt={2}
      >
        {t("pages.404.backToPrevious")}
      </Button>
    </Wrapper>
  );
}

export default Page404;
